import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { VisitContext, WorksheetApis, showToast } from '../../core';
import { WorksheetStateAction } from '../../core/domain';
import { HBox } from '../../core/layout';

interface CodingActionsProps {
  actions: WorksheetStateAction[];
  onTransition: (v: WorksheetStateAction) => void;
}

function CodingActions(props: CodingActionsProps) {
  const { actions, onTransition } = props;

  return (
    <HBox align={'flex-end'} containerStyle={{ root: { padding: '12px 18px 12px 12px' } }}>
      {actions.map((v, i) => (
        <Button key={i} id={v.label || v.action} variant="outlined" color="primary" onClick={() => onTransition(v)}>
          {v.label || v.action}
        </Button>
      ))}
    </HBox>
  );
}

type HospitalistCodingActionsDialogueProps = {
  context: VisitContext;
  onTransition?: (a: WorksheetStateAction) => void;
};

export function HospitalistCodingActionsDialogue({ context }: HospitalistCodingActionsDialogueProps) {
  const { hospitalistContext } = context;

  let selectedApi: WorksheetApis = hospitalistContext.getWorksheet();
  let transition = context.getOpenTransition() || selectedApi.transition;
  let worksheetCtx = selectedApi.context;

  const selectedActions = transition.getState().actions || worksheetCtx?.stateInfo?.actions;

  const openTransitionDialogue = transition((s) => s.openTransitionDialogue);

  const close = () => {
    if (hospitalistContext) {
      hospitalistContext.closeTransitionDialogs();
    } else {
      transition.setState({ openTransitionDialogue: false, transitionDialogueComplete: null });
    }
    if (context) {
      context.refreshRouteApis();
    }
  };

  const onTransition = async (v: WorksheetStateAction) => {
    transition = context.getOpenTransition();
    try {
      const result = await transition.getState().transition(v);
      if (!result || result?.errors?.length || !result?.success) {
        showToast(result?.errors);
      } else {
        close();
      }
    } catch (e) {
      showToast('Transition Error: ' + (e || 'Null').toString());
    }
  };

  return openTransitionDialogue && (
    <Dialog open={openTransitionDialogue} maxWidth={false} style={{ zIndex: 1531 }}>
      <DialogTitle>Select a Worksheet Action Before Continuing</DialogTitle>
      <DialogContent style={{ minWidth: 685 }}>
        <CodingActions actions={selectedActions} onTransition={onTransition} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary" variant="contained">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
